module.exports = __webpack_public_path__ + "img/no-data.acb365db.svg";